import { ShapeColor } from './ShapeColor';
import { ShapeType } from "./ShapeType";

export class Shape {
    shapeName: string;
    posX: number;
    posY: number;
    scaleX: number;
    scaleY: number;
    rot: number;
    type: ShapeType;
    color: ShapeColor;


    /**
     * Constructor
     * @param shapeName shape name.
     * @param type type of shape enum.
     * @param color the color of shape enum.
     * @param posX initial x positon.
     * @param posY initial y positon.
     * @param scaleX initial x scale.
     * @param scaleY initial y scale.
     * @param rot rotation in degrees.
     */
    constructor(shapeName: string,
        type: ShapeType,
        color: ShapeColor,
        posX: number,
        posY: number,
        scaleX: number,
        scaleY: number,
        rot: number) {
        this.shapeName = shapeName;
        this.posX = posX;
        this.posY = posY;
        this.scaleX = scaleX;
        this.scaleY = scaleY;
        this.rot = rot;
        this.type = type;
        this.color = color;
    }



}